<template>
  <div
    class="eventComp_mode_11 eventComp_mode_container"
    :class="[
      themeClass,
      modeType,
      notJumpDetailPage.includes(sportCompetitionType)
        ? 'notJumpDetailPageClass'
        : '',
    ]"
    v-show="currThemeObj"
  >
    <template v-if="tableData && tableData.length > 0">
      <div class="fixed_header" v-if="themeClass === 'onlyDisplay'">
        <span
          class="half_table_group"
          v-for="group in tableData"
          :key="group.type"
        >
          <span class="table_title" :class="group.type">
            <template v-if="group.type === 'home'">
              <span
                class="teamName"
                v-text="group.team_name"
                @click="goDetail('CSMeetDelegationDetailIndex', group)"
              ></span>
              <span class="teamLogo" :class="group.team_logo ? 'isLogo' : ''">
                <img v-if="group.team_logo" :src="group.team_logo" />
              </span>
            </template>
            <template v-if="group.type === 'away'">
              <span class="teamLogo" :class="group.team_logo ? 'isLogo' : ''">
                <img v-if="group.team_logo" :src="group.team_logo" />
              </span>
              <span
                class="teamName"
                v-text="group.team_name"
                @click="goDetail('CSMeetDelegationDetailIndex', group)"
              ></span>
            </template>
          </span>
        </span>
      </div>
      <div class="table_body">
        <span
          class="half_table_group"
          v-for="group in tableData"
          :key="group.type"
        >
          <span
            class="table_title"
            :class="group.type"
            v-if="themeClass !== 'onlyDisplay'"
          >
            <template v-if="group.type === 'home'">
              <span
                class="teamName"
                v-text="group.team_name"
                @click="goDetail('CSMeetDelegationDetailIndex', group)"
              ></span>
              <span class="teamLogo" :class="group.team_logo ? 'isLogo' : ''">
                <img v-if="group.team_logo" :src="group.team_logo" />
              </span>
            </template>
            <template v-if="group.type === 'away'">
              <span class="teamLogo" :class="group.team_logo ? 'isLogo' : ''">
                <img v-if="group.team_logo" :src="group.team_logo" />
              </span>
              <span
                class="teamName"
                v-text="group.team_name"
                @click="goDetail('CSMeetDelegationDetailIndex', group)"
              ></span>
            </template>
          </span>
          <span class="table_main" :class="group.type">
            <span class="customTable">
              <span
                class="matchItem"
                v-for="(matchItem, mIndex) in group.list"
                :key="matchItem.key"
              >
                <template
                  v-if="
                    currModeName === 'column3-matchIndex-matchType-playerInfor'
                  "
                >
                  <span class="matchItem_index" v-text="mIndex + 1"></span>
                  <span class="matchItem_type" v-text="matchItem.sign"></span>
                  <span class="matchItem_playerArea">
                    <span
                      class="customTable_row"
                      :class="currModeName"
                      v-for="rowItem in matchItem.list"
                      :key="rowItem.player_id"
                    >
                      <span
                        class="playerName-playerLogo-playerGender-teamLogo-teamName"
                        @click="goDetail('', rowItem)"
                      >
                        <span
                          class="playerLogo"
                          :class="[
                            rowItem['player_logo'] ? 'isLogo' : '',
                            rowItem['player_gender'],
                          ]"
                        >
                          <img
                            v-if="rowItem['player_logo']"
                            :src="rowItem['player_logo']"
                          />
                        </span>
                        <span class="playerOther">
                          <span class="teamInfor">
                            <span
                              class="teamLogo"
                              :class="rowItem['team_logo'] ? 'isLogo' : ''"
                            >
                              <img
                                v-if="rowItem['team_logo']"
                                :src="rowItem['team_logo']"
                              />
                            </span>
                            <!-- <span
                                class="teamName"
                                v-text="_valPerFormatHandler(rowItem['team_name'])"
                              ></span> -->
                          </span>
                          <span
                            class="playerName"
                            v-text="
                              _valPerFormatHandler(rowItem['player_name'])
                            "
                            @click="
                              goDetail('CSMeetPlayerDetailIndex', rowItem)
                            "
                          ></span>
                        </span>
                      </span>
                    </span>
                  </span>
                </template>
              </span>
            </span>
          </span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
// 适用： 羽毛球 团体 出场名单
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_11',
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    themeClass: {
      tyep: String,
      default: '',
    },
    modeType: {
      tyep: String,
      default: '', // ['single', 'double']
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_11 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      // immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      tableData: null,
      currModeName: '',
      renderModeList: [
        {
          modeName: 'column3-matchIndex-matchType-playerInfor',
          sportsIdArr: ['BDM', 'TST', 'TTE', 'TEN'],
        },
      ],
    }
  },

  mounted() {
    this.init()
  },
  methods: {
    async init() {
      console.debug(
        'mode_11  12',
        this.currSportsDetail,
        this.sportCompetitionType,
        this.datas
      )

      this.$nextTick(() => {
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId)) {
              this.currModeName = modeItem.modeName
            }
          })
        }
        this.computedModeData(JSON.parse(JSON.stringify(this.datas)))
      })
    },
    goDetail(routerName, item, id) {
      console.debug(routerName, item)
      if (this.notJumpDetailPage.includes(this.sportCompetitionType)) return
      let query = {}
      if (routerName == 'CSMeetPlayerDetailIndex') {
        query.playerId = item ? item.player_id : id
      }
      if (routerName == 'CSMeetDelegationDetailIndex') {
        query.delegationId = item ? item.team_id : id
      }
      this.pageJump(this.$router, `${routerName}_${this.currCid}`, query)
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    notDataHandler() {
      this.tableData = []
    },
    computedModeData(data) {
      console.debug('computedModeData:', data)
      if (data.subList && data.subList.length > 0 && !data.home) {
        // 羽毛球 团体 startList 情况，将subList变为home 和 away
        const keyArr = ['home', 'away']
        data.home = [] //二元数组 [[],[]] 每一场比赛里面的运动员
        data.away = []

        data.subList.forEach((group, groupIndex) => {
          const signArr = [
            { key: 'sign', name: 'sign' },
            { key: 'unit_type', name: 'unit_type_name' },
          ]
          let signItem = null
          signArr.forEach((keyItem) => {
            if (group[keyItem.key]) {
              signItem = keyItem
            }
          })
          if (signItem) {
            keyArr.forEach((key) => {
              data[key].push({
                key: `${group[signItem.key]}_${groupIndex}`,
                sign: group[signItem.name],
                list: group[key],
              })
            })
          }
        })
      }
      console.debug('mode_11:', data.home)
      let tableData = []
      if (
        data.home &&
        data.home.length > 0 &&
        data.home[0].list &&
        data.home[0].list.length > 0
      ) {
        tableData.push({
          type: 'home',
          list: data.home,
          team_id: data.home[0].list[0].team_id,
          team_name: data.home[0].list[0].team_name,
          team_logo: data.home[0].list[0].team_logo,
        })
      } else {
        if (this.modeType === 'double') {
          tableData.push({
            type: 'home',
            list: [],
            team_id: '',
            team_name: '',
            team_logo: '',
          })
        }
      }
      if (
        data.away &&
        data.away.length > 0 &&
        data.away[0].list &&
        data.home[0].list.length > 0
      ) {
        tableData.push({
          type: 'away',
          list: data.away,
          team_id: data.away[0].list[0].team_id,
          team_name: data.away[0].list[0].team_name,
          team_logo: data.away[0].list[0].team_logo,
        })
      } else {
        if (this.modeType === 'double') {
          tableData.push({
            type: 'away',
            list: [],
            team_id: '',
            team_name: '',
            team_logo: '',
          })
        }
      }
      if (tableData.length > 0) {
        this.tableData = tableData
      } else {
        this.notDataHandler()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  width: 100%;
  height: auto;
  &.notJumpDetailPageClass {
    *:not(.publishBtn) {
      cursor: default !important;
    }
  }
  &.onlyDisplay {
    margin: 1.388vw 2%;
    padding: 3.125vw 0 1.388vw 0;
    max-height: 22.7vw;
    width: 96%;
    height: auto;
    overflow-y: auto;
    .fixed_header {
      top: 1.388vw;
      left: 0;
    }
  }
  &.single {
    margin: 0.347vw;
    max-height: 21.5vw;
    width: calc(100% - 0.694vw);
    .fixed_header {
      width: calc(100% - 0.694vw);
      top: 0.347vw;
      left: 0.347vw;
    }
    .half_table_group {
      width: 100%;
      .table_main {
        &::before {
          visibility: hidden;
        }
      }
    }
  }
  .fixed_header {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .table_body {
    position: relative;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .half_table_group {
    width: 50%;
    height: auto;
    /* background-color: var(--mixtmt_greyColor8); */
    .table_title {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      color: var(--mixtmt_table_headerColor);
      width: 100%;
      height: 3.125vw;
      background-color: var(--mixtmt_table_headerBg);
      &.home {
        .teamName {
          padding-right: 0.694vw;
        }
      }
      &.away {
        .teamName {
          padding-left: 0.694vw;
        }
      }
      .teamLogo {
        width: 2.916vw;
        height: 1.944vw;
        overflow: hidden;
        background-color: var(--mixtmt_greyColor0);
        &.isLogo {
          background-color: transparent;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .teamName {
        font-size: 1.11vw;
        font-weight: bold;
      }
    }
    .table_main {
      position: relative;
      width: 100%;
      height: auto;
      color: var(--mixtmt_greyColor3);
      font-weight: bold;
      &.home {
        &::before {
          content: '\20';
          position: absolute;
          top: 0;
          right: 0;
          z-index: 2;
          width: 1px;
          height: 100%;
          background-color: var(--mixtmt_greyColor7);
        }
        .player_number {
          background-image: var(--mixtmt_homePlayerNo_bg);
        }
      }
      &.away {
        .player_number {
          background-image: var(--mixtmt_awayPlayerNo_bg);
        }
      }
      .customTable {
        width: 100%;
        height: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        .matchItem {
          width: 100%;
          height: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          border-bottom: 1px solid var(--mixtmt_greyColor7);
          .matchItem_index,
          .matchItem_type {
            font-size: 0.972vw;
            text-align: center;
            color: var(--mixtmt_greyColor3);
          }
          .matchItem_index {
            width: 2.788vw;
          }
          .matchItem_type {
            width: 4.16vw;
          }
          .matchItem_playerArea {
            width: calc(100% - 6.948vw);
            height: auto;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
          }
        }
      }

      .customTable_row {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        height: 5.55vw;
        padding: 0 0.694vw;

        .playerName-playerLogo-playerGender-teamLogo-teamName {
          height: 4.16vw;
          width: 25vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          .playerLogo {
            position: relative;
            width: 4.16vw;
            height: 4.16vw;
            border-radius: 50%;
            background-size: 100% auto;
            background-position: left 35%;
            background-repeat: no-repeat;
            background-image: var(--mixtmt_default_playerLogo);
            &::before {
              position: absolute;
              content: '\20';
              bottom: 0;
              right: 0;
              z-index: 5;
              width: 1.11vw;
              height: 1.11vw;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              background-position: center;
              /* background-image: var(--mixtmt_gender_male_icon); */
            }
            &::after {
              position: absolute;
              content: '\20';
              bottom: 0;
              right: 0;
              z-index: 2;
              width: 100%;
              height: 100%;
              border-radius: 50%;
              border: 1px solid var(--mixtmt_greyColor5);
            }
            &.F {
              &::before {
                background-image: var(--mixtmt_gender_female_icon);
              }
            }
            &.M {
              &::before {
                background-image: var(--mixtmt_gender_male_icon);
              }
            }
            &.isLogo {
              background-image: none;
            }
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 50%;
            }
          }
          .playerOther {
            width: calc(100% - 4.16vw);
            padding: 0.347vw 0.694vw;
            height: 4.16vw;
            display: flex;
            display: -webkit-flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-direction: column;
            .teamInfor {
              width: 100%;
              height: 1.66vw;
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              .teamLogo {
                width: 1.875vw;
                height: 1.25vw;
                overflow: hidden;
                background-color: var(--mixtmt_greyColor0);
                &.isLogo {
                  background-color: transparent;
                }
                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }
              .teamName {
                padding-left: 0.694vw;
                font-size: 0.972vw;
                color: var(--mixtmt_greyColor3);
              }
            }
            .playerName {
              width: auto;
              max-width: 100%;
              font-size: 0.972vw;
              height: 1.38vw;
              line-height: 1.38vw;
              color: var(--mixtmt_greyColor3);
              text-align: left;
              font-weight: bold;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .player_number {
          margin: 0 0.694vw;
          width: 3.47vw;
          height: 2.788vw;
          background-repeat: no-repeat;
          background-position: center;
          background-size: 100% 100%;
          color: var(--mixtmt_whiteColor);
          line-height: 2.788vw;
          font-size: 1.11vw;
          text-align: center;
        }
        .player_state {
          width: 6.94vw;
          color: var(--mixtmt_greyColor3);
          font-size: 1.11vw;
          text-align: center;
        }
        .player_birthDate {
          width: 9.72vw;
          color: var(--mixtmt_greyColor3);
          font-size: 1.11vw;
          text-align: center;
        }
        &.column3-matchIndex-matchType-playerInfor {
          .playerName-playerLogo-playerGender-teamLogo-teamName {
            width: 100%;
          }
        }
      }
    }
  }
}

.mixtmt_pc {
  .eventComp_mode_container {
    .half_table_group {
      .table_title {
        .teamName {
          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
      .table_main {
        .customTable_row {
          .playerName-playerLogo-playerGender-teamLogo-teamName {
            .playerOther {
              .playerName {
                &:hover {
                  cursor: pointer;
                  color: var(--mixtmt_subColor1_1);
                  text-decoration: underline;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
